import { RightOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { adminRoutes } from "router";
import { getPageBreadcrumb } from "../utils/getPageBreadcrumb";
import "../styles/PageBreadcrumb.scss";

export const PageBreadcrumb = () => {
  const location = useLocation();

  const pageBreadcrumb = useMemo(() => {
    const from = (location.state as { from?: string } | null)?.from;
    return getPageBreadcrumb(location.pathname, adminRoutes, from);
  }, [location.pathname, location.state]);

  if (!pageBreadcrumb) {
    return null;
  }

  const { title, items } = pageBreadcrumb;

  return (
    <div className="pageTitleHead">
      <nav className="pageBreadcrumbTrail" aria-label="Breadcrumb">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <span key={`${item.label}-${index}`} className="pageBreadcrumbItem">
              {index > 0 && (
                <RightOutlined className="pageBreadcrumbSep" aria-hidden />
              )}
              {!isLast && item.path ? (
                <Link to={item.path} className="pageBreadcrumbLink">
                  {item.label}
                </Link>
              ) : (
                <span
                  className={
                    isLast ? "pageBreadcrumbCurrent" : "pageBreadcrumbLink"
                  }
                  aria-current={isLast ? "page" : undefined}
                >
                  {item.label}
                </span>
              )}
            </span>
          );
        })}
      </nav>
    </div>
  );
};
